export default {
      id: "pie-chart-document-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#pie-chart-document",
      toString: function () {
        return this.url;
      }
    }